import ValidationAttemptQuestionnaireView from "./validation-attempt-questionnaire-view";

export type ValidationAttemptRow = {
  id: string;
  formKey?: string;
  customerForm?: string;
  errorKeys?: string[];
  validationErrors?: Record<string, unknown>;
  payload?: Record<string, unknown>;
  createdAt?: number | string;
};

type Props = {
  attempt?: ValidationAttemptRow | null;
};

/**
 * Modalx content: cloned partner questionnaire (view-only).
 * No submit, no document upload.
 */
export default function ValidationAttemptDetailModal({ attempt }: Props) {
  if (!attempt) {
    return null;
  }

  return <ValidationAttemptQuestionnaireView attempt={attempt} />;
}
